import { Route } from "@/shared/domain/routes";

const refund = {
  root: {
    url: "/mySale/refund",
    name: "refund",
    meta: { isPage: true },
  },
  init: {
    url: "/mySale/refund/init",
    name: "refund-init",
    meta: { isPage: true },
  },
  contract: {
    url: "/mySale/refund/contract",
    name: "refund-contract",
    meta: { isPage: false },
  },
  receipt: {
    url: "/mySale/refund/receipt",
    name: "refund-receipt",
    meta: { isPage: true },
  },
  wallet: {
    url: "/mySale/refund/wallet",
    name: "refund-wallet",
    meta: { isPage: true },
  },
} as const satisfies Route;

export default refund;
